<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body" v-if="!categoryList.length">
      無商品分類，請新增
    </div>
    <div class="box-body" v-else>
      <div class="col-xs-12">
        <div class="inline-block pull-left">
          <h4 class="pull-left">
          商品分類
          </h4>
        </div>
        <div>
          <button class="btn btn-danger m-y-10 inline-block pull-right" data-toggle="modal" data-target="#delModal" @click="delModalOpen">
            刪除
          </button>
          <button
            class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10"
            @click="gotoCrCategories"
            v-text="'新增'"
          />
          <button class="btn btn-default btn-black m-y-10 inline-block pull-right m-r-10" data-toggle="modal" @click="show.easy = !show.easy">
            <span v-if="!show.easy">簡易</span>
            <span v-else>進階</span>
          </button>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="col-xs-12 col-md-2 bg-light-gray select-element-block text-left">
          <div class="select-element" v-for="(category, index) in categoryList" :class="{'active': curId === category.item_id}" @click="clickCategory(category, index)" :disabled="isLoad || curId === category.item_id">
            <span class="text-w-600">{{category.name}}</span> <small style="opacity: .7;">&nbsp;&nbsp;{{category.remark}}</small>
          </div>
        </div>
        <div class="col-xs-12 col-md-10">
          <div class="box-body form menu-form col-xs-12">
            <div class="col-xs-12 col-md-6 p-r-5">
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>分類名稱</span>
                <input class="form-control" placeholder="" type="text" v-model="categoryInfo.name" maxlength="70">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon"><span class="text-red">＊ </span>排序</span>
                <input class="form-control" placeholder="" type="text" v-model="categoryInfo.sort" @keyup="veritySort" maxlength="4" ref="sort">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <input class="form-control" placeholder="" type="text" v-model="categoryInfo.remark" maxlength="45">
              </div>
              <br />
            </div>
            <div class="col-xs-12 col-md-6 p-l-5" v-show="!show.easy">
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <input class="form-control" placeholder="" type="text" v-model="categoryInfo.description" maxlength="45">
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">商品料號</span>
                <input class="form-control" placeholder="" type="text" v-model="categoryInfo.vendor_custom_id" maxlength="30">
              </div>
            </div>
            <div class="col-xs-12">
              <div class="input-group">
                <span class="input-group-addon">商品</span>
                <div class="form-control text-left" style="min-height: 60px">
                  <button class="btn btn-default btn-black m-y-10 inline-block " data-toggle="modal" data-target="#choseProdModal" style="position: absolute; right: 10px; top: 0px; z-index: 3;">
                    選擇商品
                  </button>
                  <div class="option-left-block">
                    <div class="inline-block m-r-10 option-chose" v-for="prod in productList" style="margin: 5px" v-if="prod.active">
                      {{prod.name}}
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="input-group">
                <span class="input-group-addon">套餐</span>
                <div class="form-control text-left" style="min-height: 60px">
                  <button class="btn btn-default btn-black m-y-10 inline-block " data-toggle="modal" data-target="#chosePackModal" style="position: absolute; right: 10px; top: 0px; z-index: 3;">
                    選擇套餐
                  </button>
                  <div class="option-left-block">
                    <div class="inline-block m-r-10 option-chose" v-for="pack in packageList" style="margin: 5px" v-if="pack.active">
                      {{pack.name}}
                    </div>
                  </div>
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-footer text-center">
      <button class="btn btn-default" @click="gotoOut">
        返回
      </button>
      <button
        v-if="!categoryList.length"
        class="btn btn-default btn-black"
        @click="gotoCrCategories"
      >
        新增
      </button>
      <button class="btn btn-success" @click="checkInputEmpty()" v-else>
        儲存
      </button>
    </div>
    <br />
    <c-modal :elementList="productList" :option="choseProduct" @trigger="trigger"></c-modal>
    <c-modal :elementList="packageList" :option="chosePackage" @trigger="trigger"></c-modal>
    <m-modal class="text-left" :option="delOption" @trigger="trigger"></m-modal>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapActions, mapGetters } from 'vuex'

import AdjustModal from './AdjustModal.vue'
import ChoseModal from '../../../elements/ChooseModal.vue'
import matcherModal from '../../../elements/Modal.vue'
import OptionModal from './OptionModal.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'CrCategoryTemp',
  extends: NdExtendHandleMenu,
  components: {
    'adjust-modal': AdjustModal,
    'option-modal': OptionModal,
    'c-modal': ChoseModal,
    'm-modal': matcherModal
  },
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      show: {
        easy: true
      },
      current: {
        option: 0,
        adjust: 0,
        adjustId: 0,
        adjustName: '',
        adjustSubType: 0
      },
      brandName: '',
      brandType: '',
      adjustNumList: [],
      adjust: [],
      option: [],
      amount: {
        adjust: 1,
        option: 1
      },
      count: 20,
      maxTotal: 0,
      categoryList: [],
      productList: [],
      packageList: [],
      categoryInfo: {
        name: '',
        sort: 1,
        vendor_custom_id: '',
        description: '',
        remark: ''
      },
      choseProduct: {
        // 配料modal資料
        id: 'choseProdModal',
        title: '選擇商品',
        event: 'chooseProduct'
      },
      chosePackage: {
        // 配料modal資料
        id: 'chosePackModal',
        title: '選擇套餐',
        event: 'choosePackage'
      },
      curId: 0,
      oldInfo: {},
      isLoad: false,
      defaultIndex: 1,
      delOption: {
        id: 'delModal',
        title: '刪除商品分類',
        body: '刪除時，若被上架中的菜單使用中，則會被阻擋<br>刪除分類時，不會刪除底下的商品，只是需要將失去分類的商品重新放到某個分類下面',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'del'
          }
        ]
      }
    }
  },
  methods: {
    ...mapActions(['setUpAdjust', 'setModal']),
    delModalOpen () {
      this.delOption.title = '刪除' + this.categoryInfo.name
    },
    trigger (event) {
      if (event === 'del') {
        this.del(this.categoryInfo.name)
      }
    },
    del (delName) {
      const url = this.base + this.id + '/category?category_id=' + this.categoryInfo.category_id
      this.getDataH('delete', url, null, (res) => {
        if (res.data.status === 200) {
          this.$notify({
            title: '提醒',
            text: '成功刪除' + delName,
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuCategory('delete')
        }
      })
    },
    toggle () {
      $(this.$refs.infoAdjustModal).css('display')
    },
    maxAmount (max) {
      if (!max) return '無限制'
      else return max
    },
    getSubType (type) {
      if (type === 10) {
        return '大小'
      } else if (type === 20) {
        return '容器'
      } else if (type === 30) {
        return '甜度'
      } else if (type === 40) {
        return '溫度'
      } else {
        return '其他'
      }
    },
    getPriceType (type) {
      if (type === 1) return '免稅價格'
      else if (type === 3) return '含稅價格'
    },
    veritySort () {
      var e = $(this.$refs.sort)
      this.categoryInfo.sort = e.val()
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    },
    getAdjustInfo () {
      const url = this.base + this.id + '/adjust/' + this.adjustId
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          this.adjustInfo = res.data.adjust
        }
      })
    },
    checkInputEmpty () {
      if (!this.allInput.name) {
        this.$notify({
          title: '提醒',
          text: '請填寫商品分類名稱',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.allInput.sort) {
        this.$notify({
          title: '提醒',
          text: '請填寫排序',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!parseInt(this.allInput.sort, 10)) {
        this.$notify({
          title: '請填寫正確排序',
          text: '排序範圍為1~9999',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.upCategory()
        return true
      }
    },
    clearData () {
      this.adjustInfo = {
        name: '',
        sort: 1,
        description: '',
        remark: '',
        price: '',
        price_type: '3',
        calorie: '',
        min_limit: '0',
        max_limit: '0',
        adjust_custom_id: '',
        is_mandatory: '0',
        is_common: '0',
        sub_type: '0'
      }
    },
    gotoCrCategories () {
      console.log('gotoCrCategories')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuCategoryCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crCategories'
      }

      this.$router.push({ name, params })
    },
    gotoOut () {
      // this.$router.push('/brandMenu/' + this.brandId)
      this.$router.go(-1)
    },
    gotoNext () {
      this.$router.push('/upProduct/' + this.brandId)
    },
    getMenuCategory (type) {
      const url = this.base + this.id + '/category/briefList'
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          const categoryList = res.data.list
          this.categoryList = categoryList
          if ((categoryList.length && !this.curId) || type === 'delete') {
            if (this.$route.query.cId) this.curId = parseInt(this.$route.query.cId, 10)
            else this.curId = categoryList[0].item_id
          }
          this.getMenuPackage()
        }
      })
    },
    getMenuPackage () {
      this.packageList = []
      const url = this.base + this.id + '/package/briefList?type=2'
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          if (res.data.list.length) {
            const categoryList = res.data.list
            categoryList.forEach((i) => {
              i.child_list.forEach((e) => {
                e.active = false
                this.packageList.push(e)
              })
            })
          }
          this.getMenuProduct()
        }
      })
    },
    getMenuProduct () {
      this.productList = []
      const url = this.base + this.id + '/product/briefList?type=2'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          if (response.data.list.length) {
            const categoryList = response.data.list[0].child_list
            categoryList.forEach((element) => {
              element.active = false
              this.productList.push(element)
            })
            this.getCategory()
          } else if (this.curId) this.getCategory()
        }
      })
    },
    getCategory () {
      const url = this.base + this.id + '/category/' + this.curId
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          $.each(res.data.category, (index, value) => {
            this.$set(this.oldInfo, index, value)
          })
          this.categoryInfo = res.data.category
          if (!this.categoryInfo.sort) {
            this.categoryInfo.sort = this.defaultIndex
            this.upCategory('sort')
          }
          this.setActiveProduct()
        }
      })
    },
    upCategory (type) {
      const url = this.base + this.id + '/category/' + this.curId
      var data = {}
      var cInfo = this.categoryInfo
      var oldInfo = this.oldInfo
      if (type === 'sort') {
        data.sort = cInfo.sort
      } else {
        // 商品
        var pList = []
        this.productList.forEach((element) => {
          if (element.active) pList.push(element.item_id)
        })
        var cList = []
        cInfo.product_list.forEach((element) => {
          cList.push(element.product_id)
        })
        // 套餐
        var paList = []
        this.packageList.forEach((element) => {
          if (element.active) paList.push(element.item_id)
        })
        var cPaList = []
        cInfo.package_list.forEach((element) => {
          cPaList.push(element.package_id)
        })
        if (cInfo.sort !== oldInfo.sort) data.sort = cInfo.sort
        if (cInfo.name !== oldInfo.name) data.name = cInfo.name
        if (cInfo.vendor_custom_id !== oldInfo.vendor_custom_id) data.vendor_custom_id = cInfo.vendor_custom_id
        if (cInfo.description !== oldInfo.description) data.description = cInfo.description
        if (cInfo.remark !== oldInfo.remark) data.remark = cInfo.remark
        if (JSON.stringify(pList) !== JSON.stringify(cList)) {
          data.product_list = pList
          data.package_list = paList
        }
        if (JSON.stringify(paList) !== JSON.stringify(cPaList)) {
          data.product_list = pList
          data.package_list = paList
        }
      }
      if (JSON.stringify(data) !== '{}') {
        this.getDataH('put', url, data, (response) => {
          if (response.data.status === 200) {
            if (!type) {
              this.$notify({
                title: '提醒',
                text: '已更新' + cInfo.name,
                duration: 3000,
                type: 'success',
                width: 400
              })
            }
            if (cInfo.name !== oldInfo.name) {
              this.getMenuCategory('reload', cInfo.category_id)
            }
          }
        })
      }
    },
    setActiveProduct () {
      var self = this
      if (self.categoryInfo.product_list.length) {
        self.categoryInfo.product_list.forEach(function (o) {
          var product = {
            active: true,
            description: o.description,
            item_id: o.product_id,
            name: o.name,
            price: o.price,
            remark: o.remark,
            vendor_custom_id: o.vendor_custom_id
          }
          self.productList.push(product)
        })
      }
      self.setActivePackage()
    },
    setActivePackage () {
      var self = this
      if (self.categoryInfo.package_list.length) {
        self.categoryInfo.package_list.forEach(function (o) {
          var pa = {
            active: true,
            description: o.description,
            item_id: o.package_id,
            name: o.name,
            price: o.price,
            remark: o.remark,
            vendor_custom_id: o.vendor_custom_id
          }
          self.packageList.push(pa)
        })
      }
      self.isLoad = false
    },
    clickCategory (category, index) {
      this.isLoad = true
      this.curId = category.item_id
      this.defaultIndex = index + 1
      this.getMenuCategory()
    }
  },
  created () {
    this.getMenuCategory()
  },
  computed: {
    ...mapGetters(['getUpAdjust', 'getModal', 'getRoleType']),
    modalState () {
      if (this.state === 3 && !this.editState) return this.adjustInfo.name
      if (this.editState) return '編輯' + this.adjustInfo.name
      else return '新增調整類別'
    },
    allInput () {
      var info = this.categoryInfo
      return {
        name: this.checkInput(info.name),
        sort: this.checkInput(info.sort),
        vendor_custom_id: this.checkInput(info.vendor_custom_id),
        description: this.checkInput(info.description),
        remark: this.checkInput(info.remark)
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    productNew () {
      var product = this.product
      return product
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    }
  }
}
</script>

<style lang="sass" scoped>
$light-gray: rgb(238, 238, 238)
$primary-color: #3c8dbc

.btn-black, .btn-black:hover, .btn-black:focus, .btn-black:active, .btn-black:active:focus
  border: 1px solid #333333
.m-r-10
  margin-right: 10px
.p-r-5
  padding-right: 5px
.p-l-5
  padding-left: 5px
.box-body.menu-form
  left: 0
  width: auto
  padding: 0px 10px
.btn.disabled, .btn[disabled], fieldset[disabled] .btn
  cursor: auto
  opacity: 1
.bg-light-gray
  background: $light-gray
.select-element
  padding: 10px 15px
  cursor: pointer
  border-bottom: 2px solid #ddd
.select-element:last-child
  border-bottom: 0px
.select-element:hover, .select-element.active
  background: $primary-color
  color: #fff
.select-element-block
  margin-bottom: 10px
  max-height: calc(100vh - 360px)
  overflow: scroll
.option-chose
  background: $primary-color
  color: #ffffff
  padding: 6px 12px
.option-left-block
  width: calc(100% - 95px)
@media screen and (max-width: 767px)
  .select-element
    padding: 5px 15px
    font-size: 16px
  .select-element-block
    margin-left: 10px
    margin-right: 10px
    height: 30vh
  .option-left-block
    width: 100%
    padding-top: 45px
</style>



// WEBPACK FOOTER //
// CrCategoryTemp.vue?eeacd654